<template>
    <div class="row m-b-sm">
        <div class="col-lg-12">
            <div class="float-e-margins">
                <div class="file-manager">
                    <form :id="'dropzone-' + id" class="dropzone-box fonts-dropzone-scrollbox">
                        <div class="dz-default dz-message">
                            <span>{{ t_drop_upload }}</span>
                        </div>
                    </form>
                    <div class="upload-warning"
                         @mouseover="warningHover = true"
                         @mouseleave="warningHover = false">
                        <div v-if="warningHover"
                             class="alert alert-warning text-center">
                            {{ t_waiting }}
                        </div>
                        <i :class="uploadingCount > 0 ? 'text-warning' : ''"
                           class="fa-solid fa-triangle-exclamation"
                           aria-hidden="true"></i>
                    </div>
                    <div class="upload-info"
                         @mouseover="infoHover = true"
                         @mouseleave="infoHover = false">
                        <div v-if="infoHover"
                             class="alert alert-info">
                            <file-type-name-limit-list :allowed-file-types="['.otf', '.ttf']" />
                        </div>
                        <i :class="erroneousUploads > 0 ? 'text-danger' : ''"
                           class="fa-solid fa-circle-info"
                           aria-hidden="true"></i>
                    </div>
                    <v-btn class="btn btn-primary btn-block fileinput-button m-t-sm">{{ t_upload }}</v-btn>
                </div>
            </div>
        </div>
        <div class="table dropzone-preview table-striped files hidden" id="fonts-preview">
            <div id="template" class="file-row">
                <div>
                    <strong class="error text-danger" data-dz-errormessage></strong>
                </div>
                <div class="progress dropzone-progress progress-striped active">
                    <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="0" role="progressbar" class="progress-bar"
                         data-dz-uploadprogress>
                        <p class="name dropzone-filename wrap-text" data-dz-name></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileTypeNameLimitList from '../../../content/common/alert/file-type-name-limit-list.vue'
    import Dropzone from "@deltablot/dropzone";

    export default {
        components: { FileTypeNameLimitList },
        props: ['id', 'global'],
        data: function () {
            return {
                t_upload: Lang.langGet("Upload Files"),
                t_drop_upload: Lang.langGet("Drop files here to upload"),
                t_unknown: Lang.langGet("Unknown"),
                t_invalid: Lang.langGet("You can't upload files of this type."),
                t_waiting: Lang.langGet("Depending on file size it may take some minutes to process the upload."),
                fileReference: 0,
                dropzoneObject: null,
                infoHover: false,
                warningHover: false,
                erroneousUploads: 0,
                uploadingCount: 0,
            }
        },
        methods: {
            filename_limitation: function (matches) {
                return Lang.langGet("File name contains illegal symbols: ' :matches '", {matches: matches});
            },
            increaseFileReference: function () {
                this.fileReference += 1;

                if (this.fileReference > 0) {
                    $('#dropzone-' + this.id + ' .dz-message').addClass('hidden');
                }
            },
            dereaseFileReference: function () {
                this.fileReference -= 1;

                if (this.fileReference <= 0) {
                    $('#dropzone-' + this.id + ' .dz-message').removeClass('hidden');
                }
            },
            init: function () {
                this.dropzoneObject = new Dropzone('#dropzone-' + this.id, {
                    url: this.global ? '/administration/font/upload-global' : '/administration/font/upload',
                    paramName: 'file',
                    timeout: 300000,
                    parallelUploads: 1,
                    chunking: true,
                    maxFilesize: Laravel.upload_max_filesize,
                    previewTemplate: document.getElementById('fonts-preview').innerHTML,
                    acceptedFiles: ['.ttf', '.otf', 'font/sfnt', 'application/vnd.ms-opentype'].join(','),
                    dictInvalidFileType: this.t_invalid,
                    headers: {
                        'X-CSRF-TOKEN': Laravel.csrfToken
                    },
                    dictDefaultMessage: Lang.langGet("Drop files here to upload"),
                    clickable: '.fileinput-button',
                    'error': (file, response) => {
                        if(file.previewElement) {
                            let message = $(file.previewElement).find('.dropzone-filename').html();
                            message = message + ': ' + response;
                            $(file.previewElement).find('.dropzone-filename').html(message);
                            $(file.previewElement).find('.dropzone-filename').addClass('bg-danger');
                            $(file.previewElement).find('[role=progressbar]').css('width', '100%');
                            $(file.previewElement).find('[role=progressbar]').addClass('progress-bar-danger');
                        }
                    },
                    'chunksUploaded': function (file, done) {
                        if(file.previewElement) {
                            file.previewElement.querySelector('.dz-processing .progress.active .progress-bar').style.width = '100%';
                        }
                        done();
                    },
                    'uploadprogress': function (file, progress, bytesSent) {
                        if(file.previewElement && progress < 100) {
                            file.previewElement.querySelector('.progress.active .progress-bar').style.width = progress + '%';
                        }
                    },
                    'complete': (file) => {
                        let timeout = 0;

                        this.uploadingCount--;
                        if (file.status === 'error') {
                            this.erroneousUploads++;
                        } else {
                            setTimeout(() => {
                                this.dropzoneObject.removeFile(file);
                                this.dereaseFileReference();
                            }, timeout);
                        }
                    },
                    'success': (data) => {
                        let responseData = JSON.parse(data.xhr.responseText);

                        if (typeof responseData.data === 'string') {
                            let message = $(data.previewElement).find('.dropzone-filename').html();
                            message = message + ': ' + this.t_unknown + ': ' + responseData.data;
                            $(data.previewElement).find('.dropzone-filename').html(message);
                            data.status = 'error';
                        } else {
                            this.$emit('uploaded', data.xhr.responseText);
                        }
                    },
                    'accept': (file, done) => {
                        this.clearFailed();
                        let filename = file.name;
                        //  pregex   /^[ _  ]/   => must not start with _
                        let pregex = /^[\x5F]/;
                        //  regex                  '[  "   *   /   :   <   >   ?   \   | ]' => do not allow those symbols
                        let regex = RegExp('[\x22\x2A\x2F\x3A\x3C\x3E\x3F\x5C\x7C]', 'g');
                        // ddregex                   '[ .  ]{2,}' => must not contain 2 or more . in sequence
                        let ddregex = RegExp('[\x2E]{2,}', 'g');
                        let uregex = regex;
                        if(Laravel.filenameRegex) {
                            uregex = RegExp(Laravel.filenameRegex, 'g');
                        }
                        let matchstring = '';
                        const match = RegExp.prototype[Symbol.match].call(pregex, filename);
                        const matches = RegExp.prototype[Symbol.matchAll].call(regex, filename);
                        const result = RegExp.prototype[Symbol.matchAll].call(uregex, filename);
                        const ddmatch = RegExp.prototype[Symbol.matchAll].call(ddregex, filename);
                        if(match)   matchstring += '_';
                        if(matches) matchstring += Array.from(matches).join(', ');
                        if(result)  matchstring +=  Array.from(result).join(', ');
                        if(ddmatch) matchstring += '..';

                        if (pregex.test(filename) || regex.test(filename) || uregex.test(filename) || ddregex.test(filename)) {
                            done(this.filename_limitation(matchstring));
                        } else {
                            done();
                        }
                    }
                });

                this.dropzoneObject.on('addedfile', (file) => {
                    this.uploadingCount++;
                    this.increaseFileReference();
                });

            },
            cancelUpload: function () {
                this.dropzoneObject.removeAllFiles(true);
            },
            clearFailed: function() {
                if(this.dropzoneObject !== null) {
                    let files = this.dropzoneObject.files;
                    for (let i = 0; i < files.length; i++) {
                        if(files[i].status === 'error' /*&& files[i].upload.progress > 100*/) {
                            this.dropzoneObject.removeFile(files[i]);
                            this.dereaseFileReference();
                            this.erroneousUploads--;
                        }
                    }
                }
            }
        },
        mounted() {
            this.init();

            EaseEventBus.listen('cancelUpload', () => {
                this.cancelUpload();
            });
        },
        watch: {
            uploadingCount(newValue) {
                this.$emit('filesToUpload', newValue);
            },
            global() {
                if (this.dropzoneObject) {
                    this.dropzoneObject.options.url = this.global ? '/administration/font/upload-global' : '/administration/font/upload';
                }
            }
        }
    }
</script>
